import React from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { authManager } from 'redux/action/auths';
import { customAxiosPostFunction } from 'utils/axiosFunction';
import { AuthEditHeaderContainer } from './AuthEditMain.css';

const AuthEditHeader = ({ selectAuth, setSelectAuth, inputAuth, setInputAuth, register }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const user = useSelector((store) => store.loginManager.status);

  const changeLevel = (selectLevel) => {
    setInputAuth((_inputAuth) => {
      return {
        ..._inputAuth,
        level: Number(selectLevel),
      };
    });
  };

  const handleDeleteAuth = (authIdx) => {
    if (!window.confirm('정말 삭제하시겠습니까?')) {
      return false;
    }

    customAxiosPostFunction(history, '/api/auth/delete', { authIdx }).then((response) => {
      if (response === 200) {
        alert('삭제되었습니다');
        dispatch(authManager());
        setInputAuth({ authIdx: 0, authNm: '', level: 1, memo: '', manageTargetAuth: null, parentAuth: null });
        setSelectAuth(null);
      } else {
        alert('삭제에 실패');
      }
    });
  };

  return (
    <AuthEditHeaderContainer>
      <div className="auth-name-input-box">
        <span>권한명</span> <input type="text" name="authNm" ref={register({ required: true, maxLength: 10 })} defaultValue={inputAuth.authNm} />
      </div>
      <div className="auth-level-input-box">
        <span>권한레벨</span>
        <select
          name="level"
          ref={register({ required: true, maxLength: 20 })}
          value={inputAuth.level}
          onChange={({ target }) => {
            changeLevel(target.value);
          }}
        >
          <option value={1}>슈퍼관리자</option>
          <option value={2}>안전관리자</option>
          <option value={3}>공장관리자</option>
          <option value={4}>공장내부관리자</option>
        </select>
      </div>
      <div className="auth-memo-input-box">
        <span>메모</span> <input type="text" name="memo" ref={register({ maxLength: 50 })} defaultValue={inputAuth.memo} />
      </div>
      {selectAuth === null && (
        <div className="auth-submit-input-box">
          <button type="submit" className="btn btn-primary">
            등록
          </button>
        </div>
      )}
      {selectAuth !== null && (
        <div className="auth-submit-input-box">
          <button type="submit" className="btn btn-primary">
            수정
          </button>
          <button
            className="btn btn-secondary"
            onClick={() => {
              setSelectAuth(null);
              setInputAuth({ authIdx: 0, authNm: '', level: 1, memo: '', manageTargetAuth: '' });
            }}
          >
            취소
          </button>
          {(user.authLevel === 1 || user.authLevel === 2) && (
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => {
                handleDeleteAuth(inputAuth.authIdx);
              }}
            >
              삭제
            </button>
          )}
        </div>
      )}
    </AuthEditHeaderContainer>
  );
};

export default AuthEditHeader;
